module.exports = __webpack_public_path__ + "img/marker_search_address.0a226166.svg";